<template>
  <div class="flexi-container">
    <flexi-top-card
      :class="!showHeader ? 'scrolled-up-card' : ''"
      v-view="inView"
      v-if="inputData.homePage"
      :inputData="inputData.homePage.top_card"
      @button-clicked="smoothScroll"
    />

    <flexi-visible when-hidden="#top-card">
      <a @click.prevent="scroll('#app')">
        <div class="arrow-down">
          <span class="text" v-text="'Go to top'"></span>
          <div class="svg"></div>
        </div>
      </a>
    </flexi-visible>

    <div class="flexi-image-editor" v-view="inView">
      <div class="image-editor">
        <br />
        <tui-image-editor
          ref="editor"
          :include-ui="useDefaultUI"
          :options="options"
        ></tui-image-editor>
        <div v-if="cdnUrl" class="image-editor--link-wrapper">
          <span v-if="!processing"
            ><a :href="cdnUrl" v-text="cdnUrl" target="_blank"
          /></span>
          <span v-else>
            <semipolar-spinner
              :animation-duration="2000"
              :size="30"
              color="#fff"
            />
          </span>
        </div>
        <div class="image-editor--btn-wrapper">
          <button
            class="btn"
            @click="getCDN()"
            :disabled="processing"
            :class="{ disabled: processing }"
          >
            <span v-if="!processing">Get CDN</span>
            <spring-spinner
              v-else
              :animation-duration="2000"
              :size="30"
              color="#fff"
            />
          </button>
          <button
            v-if="cdnUrl"
            class="btn btn-download"
            @click="downloadImage"
            v-text="'Download'"
          />
        </div>
      </div>
    </div>

    <flexi-wrapper
      v-view="inView"
      v-if="inputData.homePage"
      :inputData="inputData.homePage.sections[0]"
      @button-clicked="openModal"
    >
      <template v-slot:header="slotProps">
        <h3 class="header__title" v-text="slotProps.inputData.headerTitle" />
        <span
          class="header__subtitle"
          v-text="slotProps.inputData.headerSubtitle"
        />
        <p
          class="header__description"
          v-text="slotProps.inputData.headerDescription"
        />
        <button
          @click="scroll(slotProps.inputData.headerButtonLink)"
          class="header__button"
          v-text="slotProps.inputData.headerButtonText"
        />
      </template>
      <template v-slot:content="slotProps">
        <flexi-item
          v-for="(value, key) in slotProps.inputData.widgets"
          :key="key"
          :inputData="value"
          :index="key"
          :widgets="slotProps.inputData.widgets"
          @button-clicked="openModal"
          data-aos="fade-up"
        >
          <template v-slot:icon="{ inputData, widgets, id, index }">
            <div
              class="flexi-icon"
              @click="openModal(inputData, widgets, id, index)"
            >
              <div class="icon" v-if="key === 0">
                <svg
                  viewBox="0 -21 511.98744 511"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m377.652344 469.828125c-4.03125 0-8.148438-.511719-12.226563-1.578125l-329.898437-88.34375c-25.449219-7.019531-40.617188-33.34375-33.960938-58.773438l36.265625-139.070312c2.21875-8.535156 10.945313-13.71875 19.519531-11.433594 8.535157 2.21875 13.675782 10.964844 11.4375 19.519532l-36.269531 139.09375c-2.238281 8.574218 2.859375 17.425781 11.394531 19.773437l329.707032 88.300781c8.46875 2.238282 17.214844-2.796875 19.433594-11.222656l11.261718-45.441406c2.136719-8.574219 10.796875-13.78125 19.371094-11.6875 8.578125 2.132812 13.804688 10.792968 11.691406 19.367187l-11.304687 45.65625c-5.699219 21.609375-25.152344 35.839844-46.421875 35.839844zm0 0"
                  />
                  <path
                    d="m463.988281 341.828125h-330.667969c-26.472656 0-48-21.527344-48-48v-245.335937c0-26.472657 21.527344-48 48-48h330.667969c26.472657 0 48 21.527343 48 48v245.335937c0 26.472656-21.527343 48-48 48zm-330.667969-309.335937c-8.832031 0-16 7.167968-16 16v245.335937c0 8.832031 7.167969 16 16 16h330.667969c8.832031 0 16-7.167969 16-16v-245.335937c0-8.832032-7.167969-16-16-16zm0 0"
                  />
                  <path
                    d="m191.988281 149.828125c-23.53125 0-42.667969-19.136719-42.667969-42.667969s19.136719-42.667968 42.667969-42.667968 42.664063 19.136718 42.664063 42.667968-19.132813 42.667969-42.664063 42.667969zm0-53.335937c-5.890625 0-10.667969 4.78125-10.667969 10.667968 0 5.886719 4.777344 10.667969 10.667969 10.667969 5.886719 0 10.664063-4.78125 10.664063-10.667969 0-5.886718-4.777344-10.667968-10.664063-10.667968zm0 0"
                  />
                  <path
                    d="m101.746094 320.066406c-4.09375 0-8.191406-1.558594-11.304688-4.691406-6.25-6.25-6.25-16.386719 0-22.636719l96.425782-96.425781c14.59375-14.59375 38.335937-14.59375 52.90625 0l25.792968 25.792969 79.230469-95.105469c7.082031-8.492188 17.472656-13.398438 28.503906-13.460938 11.859375-.660156 21.460938 4.734376 28.605469 13.121094l106.199219 123.902344c5.757812 6.699219 4.96875 16.8125-1.730469 22.570312-6.71875 5.761719-16.808594 4.972657-22.570312-1.726562l-106.238282-123.945312c-1.410156-1.6875-3.136718-1.601563-4.097656-1.902344-.914062 0-2.6875.277344-4.09375 1.941406l-90.453125 108.589844c-2.882813 3.453125-7.082031 5.546875-11.5625 5.738281-4.566406.253906-8.875-1.496094-12.035156-4.671875l-38.183594-38.1875c-2.710937-2.710938-4.949219-2.710938-7.660156 0l-96.425781 96.40625c-3.117188 3.132812-7.210938 4.691406-11.308594 4.691406zm0 0"
                  />
                </svg>
              </div>
              <div class="icon" v-if="key === 1">
                <svg
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 480 480"
                  style="enable-background: new 0 0 480 480"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M432,280h-56V8c0-4.418-3.582-8-8-8H112c-4.418,0-8,3.582-8,8v272H48c-2.181,0-4.268,0.89-5.777,2.465
                        c-3.057,3.19-2.949,8.254,0.241,11.311l192,184c1.49,1.427,3.473,2.224,5.536,2.224c2.063,0,4.047-0.797,5.536-2.224l192-184
                        c1.575-1.509,2.465-3.596,2.465-5.777C440,283.581,436.418,280,432,280z M240,460.92L67.904,296H112c4.418,0,8-3.582,8-8V16h240
                        v272c0,4.418,3.582,8,8,8h44.096L240,460.92z"
                        />
                        <path
                          d="M240,120c17.673,0,32,14.327,32,32h16c-0.043-23.397-16.934-43.361-40-47.28V88h-16v16.72
                        c-26.112,4.572-43.575,29.446-39.003,55.559C197,183.142,216.789,199.866,240,200c17.673,0,32,14.327,32,32s-14.327,32-32,32
                        c-17.673,0-32-14.327-32-32h-16c0.043,23.397,16.934,43.361,40,47.28V296h16v-16.72c26.112-4.572,43.575-29.446,39.003-55.559
                        C283,200.858,263.211,184.134,240,184c-17.673,0-32-14.327-32-32S222.327,120,240,120z"
                        />
                        <rect x="136" y="32" width="16" height="16" />
                        <rect x="168" y="32" width="16" height="16" />
                        <rect x="200" y="32" width="16" height="16" />
                        <rect x="232" y="32" width="16" height="16" />
                        <rect x="264" y="32" width="16" height="16" />
                        <rect x="296" y="32" width="16" height="16" />
                        <rect x="328" y="32" width="16" height="16" />
                      </g>
                    </g>
                  </g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </div>
              <div class="icon" v-if="key === 2">
                <svg
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512 512"
                  style="enable-background: new 0 0 512 512"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <path
                        d="M296,232c-5.52,0-10,4.48-10,10s4.48,10,10,10c5.52,0,10-4.48,10-10S301.52,232,296,232z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="M256,172c-5.52,0-10,4.48-10,10s4.48,10,10,10c5.52,0,10-4.48,10-10S261.52,172,256,172z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="M136,432c-5.52,0-10,4.48-10,10c0,5.52,4.48,10,10,10s10-4.48,10-10C146,436.48,141.52,432,136,432z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="M454.416,407.678L326,179.381V58.286c11.641-4.127,20-15.248,20-28.286c0-16.542-13.458-30-30-30H196
                      c-16.542,0-30,13.458-30,30c0,13.038,8.359,24.159,20,28.286v121.095L57.584,407.678c-12.328,21.916-12.109,47.959,0.584,69.663
                      C70.86,499.043,93.448,512,118.59,512h274.82c25.142,0,47.729-12.957,60.422-34.659
                      C466.525,455.637,466.744,429.594,454.416,407.678z M204.716,186.902c0.842-1.496,1.284-3.185,1.284-4.902V60h10
                      c5.522,0,10-4.478,10-10s-4.478-10-10-10h-20c-5.514,0-10-4.486-10-10s4.486-10,10-10h120c5.514,0,10,4.486,10,10s-4.486,10-10,10
                      h-20c-5.522,0-10,4.478-10,10s4.478,10,10,10h10v122c0,1.718,0.442,3.405,1.284,4.902l58.941,104.787
                      c-35.995-2.915-71.865,4.365-104.821,21.43c-42.366,21.924-89.529,25.784-134,11.227L204.716,186.902z M436.567,467.244
                      C427.502,482.745,411.368,492,393.41,492H118.59c-17.958,0-34.092-9.255-43.157-24.756c-9.067-15.503-9.224-34.106-0.417-49.762
                      l42.408-75.392c20.576,7.185,41.84,10.812,63.437,10.812c3.197,0,6.402-0.079,9.613-0.238
                      c27.905-1.382,54.862-8.711,80.124-21.784c33.792-17.496,70.959-23.536,107.783-17.581l58.604,104.183
                      C445.791,433.138,445.635,451.741,436.567,467.244z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="M216,232c-16.542,0-30,13.458-30,30s13.458,30,30,30s30-13.458,30-30S232.542,232,216,232z M216,272
                      c-5.514,0-10-4.486-10-10c0-5.514,4.486-10,10-10c5.514,0,10,4.486,10,10C226,267.514,221.514,272,216,272z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="M376,432H176c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10h200c5.522,0,10-4.478,10-10
                      C386,436.478,381.522,432,376,432z"
                      />
                    </g>
                  </g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                  <g></g>
                </svg>
              </div>
            </div>
          </template>
        </flexi-item>
      </template>
    </flexi-wrapper>

    <flexi-wrapper
      v-view="inView"
      v-if="inputData.homePage"
      :inputData="inputData.homePage.sections[1]"
      @button-clicked="goToRoute"
    >
      <template v-slot:content>
        <div class="img" data-aos="fade-up">
          <img src="../assets/img/api-image.png" />
        </div>
      </template>
    </flexi-wrapper>

    <flexi-wrapper
      v-view="inView"
      v-if="inputData.homePage"
      :inputData="inputData.homePage.sections[2]"
      @button-clicked="goToRoute"
    >
      <template v-slot:header="slotProps">
        <h3
          class="header__title"
          v-view="1230 > currentResolution ? inView : ''"
          v-text="slotProps.inputData.headerTitle"
        />
        <span
          class="header__subtitle"
          v-text="slotProps.inputData.headerSubtitle"
        />
        <p
          class="header__description"
          v-text="slotProps.inputData.headerDescription"
        />
        <button
          @click="selectSubscription(slotProps.inputData.headerButtonLink)"
          class="header__button"
          v-text="slotProps.inputData.headerButtonText"
        />
      </template>
      <template v-slot:content="slotProps">
        <div class="flexi-price-cards">
          <div
            class="flexi-price-cards__item"
            v-for="(value, key) in slotProps.inputData.widgets"
            :key="key"
          >
            <div class="title" v-text="value.title" />
            <div class="subtitle" v-text="value.subTitle" />
            <div class="price-wrapper">
              <div class="icon">$</div>
              <div
                class="price"
                :id="'i-' + key"
                v-sectionview
                v-text="value.description"
              />
              <div class="month" v-text="'/month'" />
            </div>
            <div class="description" v-text="value.fbQuote" />
            <div class="description" v-text="value.hashtags" />
            <div class="paragraph" v-html="value.paragraph" />
            <div class="description" v-text="value.footerHeader" />
            <div class="description" v-text="value.footerText" />
            <button
              @click="selectSubscription(value.buttonLink)"
              class="button"
            >
              <span v-text="'Purchase'" />
            </button>
          </div>
        </div>
      </template>
    </flexi-wrapper>

    <flexi-modal :name="'account'">
      <template v-slot:content>
        <div class="flexi-modal__content">
          <div class="flexi-modal__content--header">
            <div class="left-card">
              <img src="../assets/img/logo_viollet.png" />
            </div>
            <div class="right-card">
              <div class="title">
                Fill the form below and create your account easy!
              </div>

              <form
                @submit.prevent="getStripeSessionId"
                id="stripe-form"
                novalidate
                data-vv-scope="stripe-form"
              >
                <div class="input-wrapper">
                  <input
                    v-model="stripe.form.email"
                    v-validate="{
                      required: true,
                      email: true,
                      uniqueEmail: true
                    }"
                    name="E-mail"
                    type="text"
                    placeholder="E-mail"
                    autocomplete="off"
                    @paste.prevent
                    :class="{ 'valid-input': errors.has('stripe-form.E-mail') }"
                    class="input-wrapper__input"
                    required
                  />
                  <validation-message
                    :message="errors.first('stripe-form.E-mail')"
                    :show="errors.has('stripe-form.E-mail')"
                  />
                </div>

                <div class="input-wrapper">
                  <input
                    v-model="stripe.form.password"
                    v-validate="{ required: true, min: 3, max: 16 }"
                    name="Password"
                    type="password"
                    placeholder="Password"
                    autocomplete="off"
                    @paste.prevent
                    :class="{
                      'valid-input': errors.has('stripe-form.Password')
                    }"
                    class="input-wrapper__input"
                    required
                  />
                  <validation-message
                    :message="errors.first('stripe-form.Password')"
                    :show="errors.has('stripe-form.Password')"
                  />
                </div>

                <div class="btn-wrapper">
                  <button class="btn" :disabled="processingSubscription">
                    <spring-spinner
                      v-if="processingSubscription"
                      :animation-duration="2000"
                      :size="30"
                      color="#000"
                    />
                    <span v-else v-text="'To Checkout'" />
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="flexi-modal__content--footer">
            <div class="title">Do you want to store a millions of images?</div>
            <div class="subtitle">
              Create an account with <span class="yellowed">IMGForce,</span>
              take advantage using our platform, and upload your images easily
              today.
            </div>
          </div>
          <div class="flexi-modal__content--pagination">
            <a href="#" class="close" />
          </div>
        </div>
      </template>
    </flexi-modal>

    <flexi-modal :name="'error'">
      <template v-slot:content>
        <div class="flexi-modal__content">
          <div class="flexi-modal__content--header">
            <div class="left-card">
              <img src="../assets/img/error-modal-left-card.png" />
            </div>
            <div class="right-card">
              <div class="title">
                Hey! Remember you have to upload your image first
              </div>
              <div class="subtitle">
                Every time you upload t-rex can drink his coffee
              </div>
              <div class="description">
                Select your favorite social network and share your images with
                your contacts or friends, if you do not have these social
                networks copy the link and paste it in the one you use. For more
                information check the about section on the page.
              </div>
              <div class="btn-wrapper">
                <button
                  class="btn"
                  v-text="'Facebook'"
                  @click="
                    redirectToSocialMedia('https://www.facebook.com/akrinum/')
                  "
                />
                <button
                  class="btn"
                  v-text="'Linkedin'"
                  @click="
                    redirectToSocialMedia(
                      'https://www.linkedin.com/company/akrinum'
                    )
                  "
                />
                <button
                  class="btn"
                  v-text="'Twitter'"
                  @click="redirectToSocialMedia('https://twitter.com/akrinum')"
                />
                <button
                  class="btn"
                  v-text="'Send Mail'"
                  @click="redirectToSocialMedia('mailto:support@imgforce.com')"
                />
              </div>
              <div class="disclaimer">
                <a href="mailto:support@imgforce.com"
                  >Problem with the platform?</a
                >
              </div>
            </div>
          </div>

          <div class="flexi-modal__content--footer">
            <div class="title">Do you want to store a millions of images?</div>
            <div class="subtitle">
              You can go <span class="yellowed">Premium</span>
              create an account and upload your images easily today.
              <span class="yellowed"
                ><a @click="closeModalAndScroll('#price')"
                  >Learn more here</a
                ></span
              >
            </div>
          </div>

          <div class="flexi-modal__content--pagination">
            <a href="#" class="close" />
          </div>
        </div>
      </template>
    </flexi-modal>

    <flexi-modal
      :name="'platform'"
      :modalData="modal"
      :modalArray="modalArrayData"
      :currentIndex="currentModalId"
    />

    <div>
      <stripe-checkout
        ref="checkoutRef"
        :pk="publishableKey"
        :session-id="stripe.sessionId"
      />
    </div>

    <flexi-advanced-last-card
      v-if="inputData.homePage"
      :inputData="inputData.homePage.last_card"
      :navigationPages="inputData.navigationPages"
      :loadingForm="loading"
      @button-clicked="sendNewsEmail"
      data-aos="fade-up"
    >
      <template v-slot:navigation="slotProps">
        <ul class="navigation-bottom">
          <li
            v-for="(value, key) in slotProps.navigationPages"
            :key="key"
            class="navigation__item"
          >
            <a
              v-if="value.name === 'Login' || value.name === 'Try Free'"
              :href="value.href"
              target="_blank"
            >
              <span v-text="value.name" />
            </a>
            <a v-else>
              <span v-text="value.name" @click="scroll(value.href)" />
            </a>
          </li>
        </ul>
      </template>
    </flexi-advanced-last-card>
  </div>
</template>

<script>
import { customTheme } from "../static/data/edtior-theme";
import { ImageEditor } from "@toast-ui/vue-image-editor";
import { mapGetters, mapActions } from "vuex";
import { StripeCheckout } from "vue-stripe-checkout";
import FlexiAdvancedLastCard from "../components/FlexiAdvancedLastCard.vue";
import FlexiModal from "../components/FlexiModal.vue";

export default {
  name: "home",
  components: {
    "tui-image-editor": ImageEditor,
    FlexiAdvancedLastCard,
    FlexiModal,
    StripeCheckout
  },
  directives: {
    sectionview: {
      inViewport(el) {
        var rect = el.getBoundingClientRect();
        var elemTop = rect.top;
        var elemBottom = rect.bottom;
        return elemTop < window.innerHeight && elemBottom >= 0;
      },
      bind(el, binding, vnode) {
        el.$onScroll = function() {
          if (binding.def.inViewport(el)) {
            var id = el.getAttribute("id");
            vnode.context.activeId = id;
            if (id === "i-0" && !vnode.context.activatedOne) {
              const number = parseInt(
                vnode.context.inputData.homePage.sections[2].widgets[0]
                  .description
              );
              vnode.context.animateValue(id, number, 1);
              vnode.context.activatedOne = true;
            } else if (id === "i-1" && !vnode.context.activatedTwo) {
              const number = parseInt(
                vnode.context.inputData.homePage.sections[2].widgets[1]
                  .description
              );
              vnode.context.animateValue(id, number);
              vnode.context.activatedTwo = true;
            } else if (id === "i-2" && !vnode.context.activatedThree) {
              const number = parseInt(
                vnode.context.inputData.homePage.sections[2].widgets[2]
                  .description
              );
              vnode.context.animateValue(id, number, 20);
              vnode.context.activatedThree = true;
            }
          }
        };
        document.addEventListener("scroll", el.$onScroll);
      },
      inserted(el) {
        el.$onScroll();
      },
      unbind(el) {
        document.removeEventListener("scroll", el.$onScroll);
        delete el.$onScroll;
      }
    }
  },
  watch: {
    $route: {
      handler(currentHash) {
        if (currentHash.hash === "#error" || currentHash.hash === "#account") {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflow = "auto";
        }
      },
      bind(el, binding, vnode) {
        el.$onScroll = function() {
          if (binding.def.inViewport(el)) {
            var id = el.getAttribute("id");
            vnode.context.activeId = id;
            if (id === "i-0" && !vnode.context.activatedOne) {
              const number = parseInt(
                vnode.context.inputData.homePage.sections[2].widgets[0]
                  .description
              );
              vnode.context.animateValue(id, number, 1);
              vnode.context.activatedOne = true;
            } else if (id === "i-1" && !vnode.context.activatedTwo) {
              const number = parseInt(
                vnode.context.inputData.homePage.sections[2].widgets[1]
                  .description
              );
              vnode.context.animateValue(id, number);
              vnode.context.activatedTwo = true;
            } else if (id === "i-2" && !vnode.context.activatedThree) {
              const number = parseInt(
                vnode.context.inputData.homePage.sections[2].widgets[2]
                  .description
              );
              vnode.context.animateValue(id, number, 20);
              vnode.context.activatedThree = true;
            }
          }
        };
        document.addEventListener("scroll", el.$onScroll);
      },
      inserted(el) {
        el.$onScroll();
      },
      unbind(el) {
        document.removeEventListener("scroll", el.$onScroll);
        delete el.$onScroll;
      }
    }
  },
  data() {
    return {
      currentResolution: window.innerWidth,
      selectedFile: null,
      activeId: "",
      activatedOne: false,
      activatedTwo: false,
      activateThree: false,
      publishableKey: process.env.VUE_APP_STRIPE_KEY,
      processingSubscription: false,
      stripe: {
        sessionId: null,
        form: {
          selectedSubscription: "",
          email: "",
          password: ""
        }
      },
      cdnUrl: null,
      processing: false,
      form: {
        img: {
          file: null,
          name: null,
          width: 0,
          height: null
        }
      },
      useDefaultUI: true,
      options: {
        cssMaxWidth: window.innerWidth,
        cssHeight: 800,
        includeUI: {
          loadImage: {
            path: "",
            name: ""
          },
          theme: customTheme
        },
        initMenu: "filter",
        usageStatistics: false
      }
    };
  },
  mounted() {
    window.scrollTo(0, 5);
    this.changeLoadButtonText();
    this.getCurrentFileInfo();
  },
  computed: {
    ...mapGetters(["inputData"])
  },
  methods: {
    ...mapActions(["postImage", "stripeSessionId"]),
    animateValue(id, value, speed = 40) {
      var val = value;
      var obj = document.getElementById(id);
      var currentCount = 0;
      var counter = setInterval(function() {
        if (currentCount < val) {
          currentCount++;
          obj.innerHTML = currentCount;
        } else {
          clearInterval(counter);
        }
      }, speed);
    },
    changeLoadButtonText() {
      var x = document.getElementsByClassName(
        "tui-image-editor-header-buttons"
      );
      x[0].children[0].childNodes[0].textContent = "Upload";
    },
    getCurrentFileInfo() {
      var selectedButton = document.getElementsByClassName(
        "tui-image-editor-load-btn"
      );
      var img = document.querySelector(".tui-image-editor-main");
      var countInterval;
      img.style.display = "none";

      countInterval = setInterval(() => {
        if (!this.selectedFile) {
          this.selectedFile = selectedButton[1].files[0];
        } else {
          clearInterval(countInterval);
          img.style.display = "block";
          selectedButton[1].style.zIndex = "0";
          selectedButton[1].style.width = "inherit";
          selectedButton[1].style.height = "inherit";
          selectedButton[1].style.inset = "unset";
        }
      }, 100);
    },
    getCDN() {
      this.processing = true;
      let width = (this.form.img.width = this.$refs.editor.invoke(
        "getCanvasSize"
      ).width);
      if (width < 2) {
        location.href = "#error";
        this.processing = false;
      }
      var img = this.$refs.editor.invoke("toDataURL");
      if (this.form.img.file === img) {
        location.href = "#error";
        this.processing = false;
      }
      if (this.form.img.file !== img) {
        this.form.img.file = this.$refs.editor.invoke("toDataURL");
        this.form.img.name = this.$refs.editor.invoke("getImageName");
        this.form.img.width = this.$refs.editor.invoke("getCanvasSize").width;
        this.form.img.height = this.$refs.editor.invoke("getCanvasSize").height;
        if (this.form.img.width !== 0) {
          this.postImage(this.form.img).then(res => {
            if (res) {
              this.cdnUrl = res;
              this.processing = false;
            }
          });
        }
      }
    },
    downloadImage() {
      setTimeout(() => {
        this.redirectToAds();
      }, 3500);
      var a = document.createElement("a");
      var linkText = document.createTextNode("my title text");
      a.appendChild(linkText);
      a.title = "my title text";
      a.href = this.form.img.file;
      a.target = "_blank";
      a.download = this.form.img.name;
      a.click();
    },
    selectSubscription(subscription) {
      this.stripe.form.selectedSubscription = subscription;
      !this.stripe.form.selectedSubscription
        ? window.open(`${process.env.VUE_APP_IMG_APP_URL}/register`, "_blank")
        : (location.href = "#account");
    },
    getStripeSessionId() {
      this.$validator.validateAll("stripe-form").then(result => {
        if (result) {
          this.processingSubscription = true;
          this.stripeSessionId(this.stripe.form).then(session_id => {
            if (session_id) {
              this.stripe.sessionId = session_id;
              this.checkout();
            }
          });
        } else {
          this.processingSubscription = false;
        }
      });
    },
    checkout() {
      this.$refs.checkoutRef.redirectToCheckout();
    }
  }
};
</script>

<style lang="scss">
// @import "~@schnapsterdog/flexi-vue/src/assets/scss/parts/_media-mixins";
</style>
